import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="home">
      <section className="hero">
        <div className="hero-content">
          <h1>Welcome to OneYard Systems Solutions</h1>
          <p>Your Complete Technology Partner for Business Excellence</p>
          <Link to="/services" className="cta-button">Explore Our Services</Link>
        </div>
        <div className="hero-overlay"></div>
      </section>

      <section className="features">
        <div className="container">
          <h2>Why Choose Us?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>Expert Team</h3>
              <p>10+ years of experience with industry-leading professionals</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Fast Delivery</h3>
              <p>Quick turnaround times without compromising quality</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💼</div>
              <h3>Trusted Partners</h3>
              <p>Over 500 happy clients across various industries</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🛡️</div>
              <h3>24/7 Support</h3>
              <p>Always available to assist you with your tech needs</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Ready to Transform Your Business?</h2>
          <p>Let us help you with cutting-edge technology solutions</p>
          <Link to="/contact" className="cta-button dark">Get Started Today</Link>
        </div>
      </section>
    </div>
  );
}

export default Home;
